<template lang="pug">
.w-switch( :class=`
  [
    {
      on,
      focus: isFocused,
      disabled,
      required,
    },
    ...inputFeedback.classes
  ]` )
  a( href='#' ).input-wrapper( 
    @click.prevent='toggle'
  )
    label
      .label {{ label }}
    .control
      .track
      .nob
        .inner
</template>

<script lang="js">
// import { Logger } from '@/lib/logger'

export const mixin = {
  props: {
    value: String,
    required: Boolean,
  },
  methods: {
    input( value ) {
      this.$emit( 'input', value )
    }
  }
}

export default {
  name: 'SwitchWidget',
  mixins: [],
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'True/False'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    validate: {
      type: [ Object, Array, Function ],
      default: () => function ( value ) {
        // Logger.debug( 'validate bool', '<f-bool>', {
        //   value,
        //   valid: isBool( value )
        // })()
        // if ( !isBool( value )) {
        //   return 'valid bool required'
        // }
      }
      // TODO: add bool validation regardless
    }
  },
  data() {
    return {
      on: false,
      inputFeedback: { classes: {}},
      isFocused: false,
    }
  },
  created() {
    this.on = !!this.value
  },
  mounted() {},
  methods: {
    toggle() {
      if ( this.disabled ) return
      this.on = !this.on
      this.$emit( 'input', this.on )
    }
  },
  computed: {},
  watch: {
    value( val ) {
      this.on = !!val
    }
  }
}
</script>

<style lang="scss">
.w-switch {
  text-decoration: none !important;
  position: relative;
  margin-bottom: var(--m-input, var(--s-base));
  color: var(--c-fg);
  padding: var(--c-p-switch, var(--s-sm));
  transition: 250ms background, 250ms opacity;
  opacity: 0.8;
  border-radius: var(--br-switch, 4px);
  &:hover, &:focus, &.focus {
    opacity: 1;
    background: rgba(0,0,0,0.1);
    label {
      text-shadow: none;
    }
  }
  * {
    color: var(--c-fg);
    /* color: #2c3e50 !important; */
    text-decoration: none !important;
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items:  center;
  }
  .control {
    position: relative;
    width: var(--s-xl);
    height: var(--s-3q);
    margin-left: var(--s-base);
    margin-right: var(--s-sm);
  }
  .track {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 1px solid var(--c-b-switch, rgba(255,255,255,0.2));
    border-radius: var(--br-switch, 100em);
    box-shadow: inset 0px 1px 1px black;
    background: var(--c-bg-switch, rgba(0,0,0,0.1));
    opacity: 0.5;
  }
  .nob {
    position: relative;
    height: var(--s-base);
    border-radius: var(--s-base);
    width: var(--s-base);
    border: 1px solid white;
    left: 0;
    transition: 300ms;
    margin: calc( 0px - var(--s-2xs));
    box-shadow: 0 1px 4px rgba(0,0,0,0.3);
    background: var(--c-fg-switch, var(--c-bg));
    .inner {
      position: relative;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      /* border: 1px solid white; */
      border-radius: 100%;
      /* box-shadow: inset 0px 2px 5px rgba(0,0,0,0.15); */
    }
  }
  &.on {
    background: var(--c-bg-switch-on, var(--c-fg));
    label {
      --c-fg: var(--c-bg);
    }
    .track {
      background: var(--c-bg-switch-on, var(--c-bg));
    }
    .nob {
      left: calc( 100% - var(--s-3q));
    }
  }
  &.disabled {
    opacity: 0.5;
    &, label, .label {
      text-shadow: 0 1px 1px white;
      color: transparent;
      background-clip: text;
      background-color: rgba(0,0,0,0.5);
    }
    .track {
      background: var(--c-bg-switch-disabled, var(--c-bg));
    }
  }
  label, .label {
    text-shadow: none;
    padding: 0;
    margin: 0;
  }
  &.required {
    .input-wrapper {
      > label {
        .label {
          &::after {
            content: " *"
          }
        }
      }
    }
  }
}
</style>
